import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';
import Button from '../../components/Form/Button';
import Input from '../../components/Form/Input';
import './Login.css';

const VerifyOTP = () => {
    const navigate = useNavigate();
    const { verifyOtp } = useAuth();
    const { showToast } = useToast();
    const [otp, setOtp] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const value = e.target.value;
        // Only allow numeric input and limit to 6 digits
        if (/^\d*$/.test(value) && value.length <= 6) {
            setOtp(value);
            // Clear error when user starts typing
            if (error) setError('');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        // Validate OTP
        if (!otp || otp.length !== 6) {
            setError('Please enter a valid 6-digit OTP');
            setLoading(false);
            return;
        }

        // Attempt OTP verification
        const result = await verifyOtp(otp);

        if (result.success) {
            showToast('OTP verified successfully!', 'success');

            // Store role in localStorage for AppContext backward compatibility
            localStorage.setItem('currentRole', result.user.user_type);
            console.log("my own access token::::::", result);
            // Redirect based on role
            const role = result.user.user_type;
            console.log("role::::::::::::::", result.user);
            if (role === 'admin') {
                navigate('/admin/dashboard');
            } else if (role === 'manager') {
                navigate('/manager/dashboard');
            } else if (role === 'agent') {
                navigate('/agent/dashboard');
            }
        } else {
            setError(result.error || 'OTP verification failed');
            showToast(result.error || 'OTP verification failed', 'error');
        }

        setLoading(false);
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <div className="login-logo">
                        <img
                            src="/logo-2.png"
                            alt="Apna Pump Logo"
                            className="login-logo-icon"
                        />
                    </div>
                </div>

                <form onSubmit={handleSubmit} className="login-body">
                    <div className="login-form">
                        <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>
                            Verify OTP
                        </h2>
                        <p style={{ textAlign: 'center', marginBottom: '20px', color: '#666' }}>
                            Enter the 6-digit OTP sent to your email
                        </p>

                        <Input
                            label="OTP"
                            type="text"
                            name="otp"
                            value={otp}
                            onChange={handleChange}
                            placeholder="Enter 6-digit OTP"
                            required
                            autoComplete="one-time-code"
                            inputMode="numeric"
                        />

                        {error && (
                            <div className="login-error">
                                <span>⚠️</span>
                                <span>{error}</span>
                            </div>
                        )}

                        <Button
                            type="submit"
                            variant="primary"
                            size="large"
                            className="login-button"
                            loading={loading}
                        >
                            Verify OTP
                        </Button>

                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <button
                                type="button"
                                onClick={() => navigate('/login')}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#007bff',
                                    cursor: 'pointer',
                                    textDecoration: 'underline'
                                }}
                            >
                                Back to Login
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default VerifyOTP;
